import React from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/footer";
import LegalLayout from "../common/LegalLayout";
import SEOHead from "../SEO/SEOHead";
import "../../css/MainPage.css";

export default function TermsCondition() {
  const sections = [
    {
      title: "1. Use of Services",
      content: [
        "1.1 Eligibility: You must be at least 18 years old to use our services. By using our services, you represent and warrant that you are at least 18 years old.",
        "1.2 Account: Some services may require you to create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account."
      ]
    },
    {
      title: "2. Intellectual Property",
      content: [
        "2.1 Ownership: All content, including but not limited to text, graphics, logos, images, and software, available on our Website is the property of Robotico Digital or its licensors and is protected by intellectual property laws.",
        "2.2 License: Subject to these Terms, we grant you a limited, non-exclusive, non-transferable license to use our services for your personal or internal business purposes."
      ]
    },
    {
      title: "3. Prohibited Activities",
      content: [
        "You agree not to:",
        "• Use our services for any unlawful purpose.",
        "• Attempt to gain unauthorized access to our systems or networks.",
        "• Interfere with the proper functioning of our services.",
        "• Modify, adapt, translate, reverse engineer, or decompile any portion of our Website."
      ]
    },
    {
      title: "4. Privacy",
      content: [
        "4.1 Our Privacy Policy governs the collection, use, and disclosure of your personal information. By using our services, you consent to the collection and use of your personal information as described in our Privacy Policy."
      ]
    },
    {
      title: "5. Disclaimer of Warranties",
      content: [
        '5.1 Our services are provided on an "as is" and "as available" basis without any warranties, express or implied. We do not warrant that our services will be uninterrupted, secure, or error-free.'
      ]
    },
    {
      title: "6. Limitation of Liability",
      content: [
        "6.1 In no event shall Robotico Digital be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or in connection with your use of our services."
      ]
    },
    {
      title: "7. Indemnification",
      content: [
        "7.1 You agree to indemnify and hold harmless Robotico Digital, its affiliates, officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses arising out of or in connection with your use of our services."
      ]
    },
    {
      title: "8. Governing Law",
      content: [
        "8.1 These Terms shall be governed by and construed in accordance with the laws of Karnataka, India, without regard to its conflict of law provisions."
      ]
    },
    {
      title: "9. Changes to Terms",
      content: [
        "9.1 We reserve the right to modify or update these Terms at any time without prior notice. Your continued use of our services after any changes to these Terms constitutes acceptance of such changes."
      ]
    },
    {
      title: "10. Contact Us",
      content: [
        <>
          10.1 If you have any questions or concerns about these Terms, please write to us at{" "}
          <a href="mailto:info@roboticodigital.com" className="email-link">
            info@roboticodigital.com
          </a>{" "}
          or refer to our <Link to="/contact">contact page</Link> for more details.
        </>
      ]
    }
  ];

  return (
    <>
    <SEOHead
        title="Terms & Conditions | Froth TestOps"
        description="Review the terms and conditions for using Froth TestOps. Understand your rights, responsibilities, and the rules that govern our services."
        keywords="Froth TestOps terms and conditions"
      />
    <div className="fd-main-wrapper page-padding">
      <Header />
      <main>
        <LegalLayout
          crumbs="Terms & Conditions"
          title="Terms &"
          highlight="Conditions"
          lead="The rules for using Froth TestOps and this website. Please read them carefully."
          sections={sections.map(s => ({ title: s.title, items: s.content }))}
        />
      </main>
      <Footer />
    </div>
    </>
  );
}